var routes = [{
  path: '/',
  component: function component() {
    return import('layouts/Default.vue');
  },
  children: [{
    path: '',
    redirect: '/card',
    component: function component() {
      return import('pages/Card.vue');
    }
  }, {
    path: 'card',
    component: function component() {
      return import('pages/Card.vue');
    },
    meta: {
      requiresAuth: true,
      mobileOnly: true
    }
  }, {
    path: 'affiliates',
    component: function component() {
      return import('pages/Affiliates.vue');
    }
  }, {
    path: 'affiliates/category/:categoryId',
    component: function component() {
      return import('pages/Affiliates.vue');
    }
  }, {
    path: 'affiliates/view/:id',
    component: function component() {
      return import('pages/Affiliate.vue');
    }
  }, {
    path: 'affiliates/map/:id',
    component: function component() {
      return import('pages/AffiliateMap.vue');
    },
    meta: {
      mobileOnly: true
    }
  }, {
    path: 'map',
    component: function component() {
      return import('pages/AffiliatesMap.vue');
    }
  }, {
    path: 'map/category/:categoryId',
    component: function component() {
      return import('pages/AffiliatesMap.vue');
    }
  }, {
    path: 'favorites',
    component: function component() {
      return import('pages/Favorites.vue');
    },
    meta: {
      requiresAuth: true,
      mobileOnly: true
    }
  }, {
    path: 'login',
    component: function component() {
      return import('pages/Login.vue');
    },
    meta: {
      mobileOnly: true
    }
  }, {
    path: 'page/:codename',
    component: function component() {
      return import('pages/Page.vue');
    }
  }]
}]; // Always leave this as last one

if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: function component() {
      return import('pages/Error404.vue');
    }
  });
}

export default routes;